{
  "version": 1,
  "asset_id": "f24818aa-0ffb-4727-b59c-8e0307e87897",
  "project_id": "115256dd-a6cc-4bc1-95c1-d787d4c0e481",
  "url": "/__l5e/assets-v1/f24818aa-0ffb-4727-b59c-8e0307e87897/rv_furniture.webp",
  "r2_key": "a/v1/115256dd-a6cc-4bc1-95c1-d787d4c0e481/f24818aa-0ffb-4727-b59c-8e0307e87897/rv_furniture.webp",
  "original_filename": "rv_furniture.webp",
  "size": 29160,
  "content_type": "image/webp",
  "created_at": "2026-07-14T02:53:25Z"
}
